const loadScheduleFormPage = () => import('views/ScheduleFormPage');
const loadJobForm = () => import('components/JobForm/JobForm');
const loadJobDetailsPage = () => import('views/JobDetailsPage');

export const prefetchScheduleFormRoute = async () => {
  await Promise.all([loadScheduleFormPage(), loadJobForm()]);
};

export const prefetchJobDetailsRoute = async () => {
  await loadJobDetailsPage();
};

export const scheduleRoutePrefetchOnIdle = () => {
  if (typeof window === 'undefined') {
    return () => undefined;
  }

  if ('requestIdleCallback' in window) {
    const idleId = window.requestIdleCallback(() => {
      void prefetchScheduleFormRoute();
      void prefetchJobDetailsRoute();
    });

    return () => window.cancelIdleCallback(idleId);
  }

  const timeoutId = window.setTimeout(() => {
    void prefetchScheduleFormRoute();
    void prefetchJobDetailsRoute();
  }, 300);

  return () => window.clearTimeout(timeoutId);
};